import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  // Show loading state while checking authentication
  if (loading) {
    return <div>Loading...</div>
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to='/login' replace />
  }

  // Render children if authenticated
  return children
}

// PropTypes for type checking
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
}
